import { get } from 'vuex-pathify';
export default {
  computed: {
    isSendMessageSettingsEnabled: get('admin/settingsValues@send_message_module_enabled'),
    isSendMessageModuleEnabled: get('admin/additionalModules@SEND_MESSAGE_MODULE.enabled'),
    hasSendMessagePermissions() {
      return this.$store.get('users/toolsPermissions')['SEND_MESSAGE_MODULE'].main_value > 0;
    },
    isSendMessageVisible() {
      return (
        this.isSendMessageSettingsEnabled &&
        this.isSendMessageModuleEnabled &&
        this.hasSendMessagePermissions &&
        this.hasGeometry
      );
    },
    sendMessageButton() {
      return this.isSendMessageVisible
        ? [
            {
              name: 'sendMessage',
              icon: 'mdi-email',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('button.sendMessage')
                : this.$i18n.t('button.toSendMessage', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
    watermetersLayerId() {
      return this.$_objectToArray(this.layers).find(layer => layer.role === 'water_watermeters')?.id || null;
    },
    isWatermetersLayer() {
      return this.currentLayer?.id === this.watermetersLayerId;
    },
    billingSmsSendingEnabled: get('admin/settingsValues@billing_sms_sending_enabled'),
    isBillingSendMessageVisible() {
      return this.billingSmsSendingEnabled && this.isWatermetersLayer;
    },
    sendBillingMessageButton() {
      return this.isBillingSendMessageVisible
        ? [
            {
              name: 'sendBillingMessage',
              icon: 'mdi-cellphone-message',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('button.sendSms')
                : this.$i18n.t('button.toSendSms', {
                    suffix: this.$i18n.t('button.atLeastOneSelected'),
                  }),
              fontSize: '20px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
  },
  data: () => ({
    isSendMessageDialogVisible: false,
    isSendMessageDialogLoaded: false,
    isSendBillingMessageDialogVisible: false,
    isSendBillingMessageDialogLoaded: false,
  }),
  methods: {
    sendMessageAction() {
      this.isSendMessageDialogLoaded = true;
      this.isSendMessageDialogVisible = true;
    },
    sendBillingMessageAction() {
      this.isSendBillingMessageDialogLoaded = true;
      this.isSendBillingMessageDialogVisible = true;
    },
  },
};
